const addFolder = (state, folder) => ({
  ...state,
  [folder.id]: folder,
});

const removeFolder = (state, localId) => {
  const newState = { ...state };
  delete newState[localId];
  return newState;
};

export default (state, action) => {
  const {
    status,
    payload: { folder, localId },
  } = action;

  switch (status) {
    case 'started':
      return addFolder(state, folder);
    case 'success':
      return removeFolder(addFolder(state, folder), localId);
    case 'error':
      return removeFolder(state, localId);
    default:
      return state;
  }
};
